import React from "react";
import ProductCard from "@/components/ProductCard";
import { useWishlist } from "@/context/WishlistContext";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Wishlist = () => {
  const { items } = useWishlist();
  return (
    <div className="mx-auto max-w-7xl px-6 md:px-10 py-12" data-testid="wishlist-page">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="tick-label mb-2">Your saved items</div>
          <h1 className="font-heading text-4xl text-[#2C3E2D] font-medium">Wishlist</h1>
          <p className="text-sm text-[#6B7B6C] mt-2">Products you've saved for later.</p>
        </div>
      </div>
      {items.length === 0 ? (
        <div className="rounded-2xl border border-[#E5E5E0] bg-white p-16 text-center" data-testid="wishlist-empty">
          <div className="mx-auto h-16 w-16 rounded-full bg-[#F0EFEA] flex items-center justify-center mb-3">
            <Heart className="h-6 w-6 text-[#E07A5F]" />
          </div>
          <p className="text-[#2C3E2D] font-medium">No items saved yet</p>
          <p className="text-sm text-[#6B7B6C] mt-1">Tap the heart icon on any product to add it here.</p>
          <Link to="/shop">
            <Button className="btn-primary rounded-full mt-6 px-6" data-testid="wishlist-shop-btn">Browse the market</Button>
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="wishlist-grid">
          {items.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
